<adm-type-ahead-selector2
  label="Vælg lokation"
  [fetchFn]="fetchLocations"
  [initialId]="initialId() ?? undefined"
  (itemSelected)="locationSelected($event)"
  [fetchByIdFn]="fetchLocationsById"
  [itemTemplate]="itemTemplate() ?? defItemTemplate"
  [identityPropertyName]="filterByProp()"
  (clearTypeAhead)="clearTypeAhead.emit()"
  [placeholder]="placeholder()"
  [resetTrigger]="resetTrigger()"></adm-type-ahead-selector2>

<ng-template #defItemTemplate let-item>
  <div class="location-option">
    <span class="location">
      <strong>{{ item.name }}</strong>
      <span class="icon-with-text">
        <mat-icon [matTooltip]="'Addresse'">my_location</mat-icon>
        {{ item.formattedAddress }}
      </span>
    </span>
  </div>
</ng-template>
